import {observer} from "mobx-react";
import * as React from "react";
import {computed, observable} from "mobx";
import InvalidBubble from "components/signup/shared/InvalidBubble";
import {SignupInput} from "components/signup/SignupInput";
import {UIState} from "data/UIState";

interface IEmployeeOrSpouseBlockProps {
  employeeOrSpouse: string;
  //employeeOrSpouseInvalid: boolean;
  updateEmployeeOrSpouse: (employeeOrSpouse: string) => void;
  employeeName: string;
  //employeeNameInvalid: boolean;
  updateEmployeeName: (name: string) => void;
  employeeNameInvalid:boolean;
}

export const EOS = {
  employee:'Employee',
  spouse:'Partner or Spouse'
}

@observer
export class EmployeeOrSpouseBlock extends React.Component<IEmployeeOrSpouseBlockProps> {

  constructor(props: IEmployeeOrSpouseBlockProps) {
    super(props);
    console.log("EmployeeOrSpouseBlock");
    if(UIState.settings.EXCLUDE_EMPLOYEE_REGISTRATION) {
      this.handleSetToSpouse();
    }
  }

  handleSetToEmployee = () => {
    this.props.updateEmployeeOrSpouse(EOS.employee);
  }

  handleSetToSpouse = () => {
    this.props.updateEmployeeOrSpouse(EOS.spouse);
  }

  handleUpdateAffiliation = (affiliation) => {
    this.props.updateEmployeeOrSpouse(affiliation);
  }

  @computed
  get showEmployeeName() {
    return this.props.employeeOrSpouse === EOS.spouse && UIState.settings.NAME_OF_EMPLOYEE_IF_SPOUSE;
  }

  @computed
  get iam() {
    return UIState.settings.SPOUSE_LABEL ? UIState.settings.SPOUSE_LABEL : `I am the ${UIState.settings.INCLUDE_PARTNER_WITH_SPOUSE ? 'Partner or ' : ''}Spouse of an Employee`;
  }

  @observable name = '';

  render() {
    if (!UIState.settings.ASK_FOR_EMPLOYEE_OR_SPOUSE && !(UIState.settings.ADDITIONAL_AFFILIATIONS && UIState.settings.ADDITIONAL_AFFILIATIONS.length > 0)) {
      return null;
    } else {
      return (
        <div>
          <div className={"form-element"}>

            <fieldset>
            <legend>How are you associated with {UIState.settings.COMPANY_NAME}?</legend>

              {!UIState.settings.EXCLUDE_EMPLOYEE_REGISTRATION &&
              <div className="radio">
              <label htmlFor={"employee"}><input onClick={this.handleSetToEmployee} onChange={() => {
              }} type="radio" id={"employee"} name="eos" checked={this.props.employeeOrSpouse === EOS.employee}/>
                I am an Employee</label>
              </div>
              }

            {UIState.settings.ASK_FOR_EMPLOYEE_OR_SPOUSE &&
              <>
                <div className="radio">
                  <label htmlFor={"spouse"}><input onClick={this.handleSetToSpouse} onChange={() => {
                  }} type="radio" id={"spouse"} name="eos" checked={this.props.employeeOrSpouse === EOS.spouse}/>
                  {this.iam}</label>
                </div>
                {UIState.settings.NAME_OF_EMPLOYEE_IF_SPOUSE &&
                  <SignupInput
                    id={"employeeName"}
                    placeholder="enter employee name"
                    value={this.props.employeeName}
                    updateValue={this.props.updateEmployeeName}
                    inputName="relatedemployeename"
                    disabled={!this.showEmployeeName}
                    style={{
                      marginLeft: '26px',
                      minWidth: '250px'
                    }}
                  />
                }
                <InvalidBubble label={'Employee Name is required'} show={this.props.employeeNameInvalid}/>
            </>
            }

            {UIState.settings.ADDITIONAL_AFFILIATIONS && UIState.settings.ADDITIONAL_AFFILIATIONS.length > 0 &&
              <React.Fragment>
                {UIState.settings.ADDITIONAL_AFFILIATIONS.map((affiliation, idx) =>
                  <div key={idx} className="radio">
                    <label htmlFor={`addl-${idx}`}>
                      <input
                          id={`addl-${idx}`}
                          onClick={() => {
                            this.handleUpdateAffiliation(affiliation.value);
                          }}
                          onChange={() => {
                          }}
                          type="radio"
                          name="eos"
                          checked={this.props.employeeOrSpouse === affiliation.value}
                      />{affiliation.label}</label>

                  </div>
                )}
              </React.Fragment>
            }
            {/*<InvalidBubble label={'Please select one!'} show={this.props.employeeOrSpouseInvalid}/>*/}
            </fieldset>
          </div>


        </div>
      );
    }
  }
}
